"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._NativeJsString = exports._NativeJsBoolean = void 0;
// In ./Boolean.ts and ./String.ts, the native Boolean and String types
// are shadowed by the export class defined in the file, but said class
// definitions still need to reference the original class definitions.
// This provides a mechanism for doing so.
exports._NativeJsBoolean = Boolean;
exports._NativeJsString = String;
